export const Hosts = {
    EditorX: 'editorX',
    Editor: 'editor',
    DataBinding: 'dataBinding',
    DocumentManagement: 'documentManagement',
    Thunderbolt: 'thunderbolt',
    ThunderboltPreview: 'thunderboltPreview',
    Corvid: 'corvid',
    SiteAssets: 'siteAssets',
};
//# sourceMappingURL=hosts.js.map